
import { createContext, useContext, useState } from "react";

const BreadcrumbContext = createContext<any>(null);

export const BreadcrumbProvider = ({ children }: any) => {
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  return (
    <BreadcrumbContext.Provider value={{ breadcrumbs, setBreadcrumbs }}>
      {children}
    </BreadcrumbContext.Provider>
  );
};

export const useBreadcrumbs = () => useContext(BreadcrumbContext);